import { render, staticRenderFns } from "./parcel-list-table.vue?vue&type=template&id=28c23943"
import script from "./parcel-list-table.vue?vue&type=script&lang=ts"
export * from "./parcel-list-table.vue?vue&type=script&lang=ts"
import style0 from "./parcel-list-table.vue?vue&type=style&index=0&id=28c23943&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports